module.exports = require('./lib/react-download');


/*****************
 ** WEBPACK FOOTER
 ** ./~/@axetroy/react-download/index.js
 ** module id = 689
 ** module chunks = 0
 **/